import { useState } from 'react';
import styles from '../../css/Search.module.css';

export default function SearchControl({
	state,
  setState,
  searchGubun,
  setSearcGubun,
  searchItem,
  setSearcItem,
  handleReangeChange
}) {

  // the width of the box
  const [width, setWidth] = useState(100);

  // the height of the box
  const [height, setHeight] = useState(100);

  // This function is called when the first range slider changes
  const changeWidth = (event) => {
    setWidth(event.target.value);
  };

  // This function is called when the second range slider changes
  const changeHeight = (event) => {
    setHeight(event.target.value);
  };

	const handleGubun = (type) => {
    setSearcGubun(type);
  };

  const handleItem = (type) => {
    setSearcItem(type);
  };

  const handleListOpen = () => {
    handleReangeChange();
    setState({ ...state, search: !state.search });
  }

	return (
		<>
      <div className={`${styles.wrap} ${styles.contents}`}>
        <div className={styles.rangeBox}>
          <ul>
            <li className={styles.gubun}>
              <input type='radio'
                name='gubun'
                id='high'
                onChange={(e) => handleGubun('상위')}
                checked={searchGubun === '상위'}
              />
              <label htmlFor='high'>상위</label>
            </li>
            <li className={styles.gubun}>
              <input type='radio'
                name='gubun'
                id='low'
                onChange={(e) => handleGubun('하위')}
                checked={searchGubun === '하위'}
                />
              <label htmlFor='low'>하위</label>
            </li>
          </ul>
          <ul>
            <li className={styles.item}>
              <input type='radio'
                name='cluster'
                id='10'
                onChange={(e) => handleItem('10')}
                checked={searchItem === '10'}
              />
              <label htmlFor='10'>10</label>
            </li>
            <li className={styles.item}>
              <input type='radio'
                name='cluster'
                id='20'
                onChange={(e) => handleItem('20')}
                checked={searchItem === '20'}
              />
              <label htmlFor='20'>20</label>
            </li>
            <li className={styles.item}>
              <input type='radio'
                name='cluster'
                id='30'
                onChange={(e) => handleItem('30')}
                checked={searchItem === '30'}
              />
              <label htmlFor='30'>30</label>
            </li>
          </ul>
          <button type='submit' onClick={handleListOpen}
              disabled={searchItem.length === 0 || searchGubun.length === 0}
              style={searchItem.length === 0 || searchGubun.length === 0 ? 
              {cursor: 'not-allowed', backgroundColor: '#edecec', color: '#000'} : 
              {cursor: 'pointer', backgroundColor: 'rgb(134, 178, 253)', color:'#fff'}}
          >확인</button>
        </div>
      </div>
		</>
	)
}